import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Link } from 'react-router-dom';
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';

import logo from '../../submodule/img/Workld_Logo_Color_Hor_2-page-1.png';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../redux/actions/user/logoutUser';
import { setAuth } from '../../redux/slices/app.slice';
import Loading from '../Loading/Loading';
import { resetLogoutUser } from '../../redux/slices/user.slice';
import { resetGetEmployerList } from '../../redux/slices/employer.slice';
import { resetGetVacancyList } from '../../redux/slices/dashboard.slice';
import { usePermissions } from '../../hooks/usePermissions';
import { PERMISSIONS } from '../../constants/permissions';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
function NavBar() {
  const [navPage, setNavPage] = useState(null);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { hasPermission } = usePermissions();
  const {
    logoutUser: { data: logoutUserData, error: logoutUserError, loading: logoutUserLoading },
  } = useSelector((state) => state.user);
  const {
    getMe: { data: getMeData, error: getMeError, loading: getMeLoading },
  } = useSelector((state) => state.user);
  const {
    getEmployerList: { data: getEmployerListData, error: getEmployerListError, loading: getEmployerListLoading },
  } = useSelector((state) => state.employer);
  const {
    getVacancyList: { data: getVacancyListData, error: getVacancyListError, loading: getVacancyListLoading },
  } = useSelector((state) => state.dashboard);

  const onLogout = () => {
    dispatch(logoutUser());
  };
  const goVacancy = () => {
    localStorage.setItem('tabState', 'active');
    navigate('/vacancy');
  };

  useEffect(() => {
    if (logoutUserData || logoutUserError) {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      dispatch(setAuth(false));
      navigate('/login');
    }
  }, [logoutUserData, logoutUserError]);
  useEffect(() => {
    return () => {
      dispatch(resetLogoutUser());
    };
  }, []);
  useEffect(() => {
    if (navPage && !getEmployerListData && !getVacancyListData) {
      navigate(navPage);
      setNavPage(null);
    }
  }, [navPage]);

  return (
    <div className="">
      {logoutUserLoading && <Loading className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50" />}
      <nav className="flex lg:justify-evenly justify-center mt-5 lg:ml-16 text-slate-900 font-semibold text-sm">
        <div className="lg:flex uppercase  items-center justify-center">
          <div className="sm:mr-10 flex items-center">
            <Link
              onClick={() => {
                dispatch(resetGetEmployerList());
                dispatch(resetGetVacancyList());
                setNavPage(`/`);
              }}>
              <img src={logo} alt="" className="sm:h-10 xs:h-7 h-6 mt-1" />
            </Link>
          </div>
          <div className="hidden lg:block min-w-[536px]">
            <ul className="flex gap-10 font-semibold mt-2 tracking-widest">
              {hasPermission(PERMISSIONS.VIEW_VACANCY) && (
                <li
                  className="cursor-pointer hover:text-emerald-500 transition ease-in-out duration-300"
                  onClick={() => {
                    dispatch(resetGetEmployerList());
                    dispatch(resetGetVacancyList());
                    setNavPage(`/vacancy`);
                  }}>
                  Вакансии
                </li>
              )}

              {hasPermission(PERMISSIONS.VIEW_EMPLOYER) && (
                <li className="cursor-pointer hover:text-emerald-500 transition ease-in-out duration-300">
                  <Link
                    onClick={() => {
                      dispatch(resetGetEmployerList());
                      dispatch(resetGetVacancyList());
                      setNavPage(`/contractor`);
                    }}>
                    Контрагенты
                  </Link>
                </li>
              )}
              {hasPermission(PERMISSIONS.VIEW_CANDIDATE) && (
                <li className="cursor-pointer hover:text-emerald-500 transition ease-in-out duration-300">
                  <Link to={`/applicants`}>Соискатели</Link>
                </li>
              )}
              {hasPermission(PERMISSIONS.VIEW_CHAT) && (
                <li className="relative cursor-pointer hover:text-emerald-500 transition ease-in-out duration-300">
                  <Link to={`/chats`}>
                    Сообщения
                    {/* <span className="absolute inline-flex items-center px-1 top-[-10px] rounded-full text-xs font-medium bg-teal-500 text-white">3</span> */}
                  </Link>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="text-md ml-3.5 flex justify-center items-center lg:w-auto">
          <Menu as="div" className="relative inline-block text-left mt-1">
            <div>
              <Menu.Button className="inline-flex w-full justify-center items-center gap-x-1.5 font-normal px-3 text-gray-900 cursor-pointer hover:text-emerald-500 transition ease-in-out duration-300 text-sm xs:text-base">
                {getMeData?.role == 'admin' ? 'Администратор' : 'Менеджер'}

                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-down-fill" viewBox="0 0 16 16">
                  <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"></path>
                </svg>
              </Menu.Button>
            </div>
            <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
              <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="py-1">
                  <Menu.Item>
                    {({ active }) => (
                      <Link to={`/manage`} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'flex px-4 py-2 text-sm')}>
                        Управление
                      </Link>
                    )}
                  </Menu.Item>
                  <Menu.Item>
                    {({ active }) => (
                      <div onClick={onLogout} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm cursor-pointer')}>
                        Выйти
                      </div>
                    )}
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
        <div className="lg:hidden sm:flex flex-shrink-0 items-center justify-end ">
          <Menu as="div" className="relative inline-block text-left w-full">
            <div>
              <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 hover:text-[#00B2A4]">
                <svg className="w-6 h-6 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1h15M1 7h15M1 13h15"></path>
                </svg>
              </Menu.Button>
            </div>
            <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
              <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="py-1">
                  {hasPermission(PERMISSIONS.VIEW_VACANCY) && (
                    <Menu.Item className="flex hover:text-[#00B2A4]">
                      {({ active }) => (
                        <Link to={`/vacancy`} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm uppercase')}>
                          Вакансии
                        </Link>
                      )}
                    </Menu.Item>
                  )}

                  {hasPermission(PERMISSIONS.VIEW_EMPLOYER) && (
                    <Menu.Item className="flex hover:text-[#00B2A4]">
                      {({ active }) => (
                        <Link to={`/contractor`} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm uppercase')}>
                          Контрагенты
                        </Link>
                      )}
                    </Menu.Item>
                  )}
                  {hasPermission(PERMISSIONS.VIEW_CANDIDATE) && (
                    <Menu.Item className="flex hover:text-[#00B2A4]">
                      {({ active }) => (
                        <Link to={`/applicants`} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm uppercase')}>
                          Соискатели
                        </Link>
                      )}
                    </Menu.Item>
                  )}
                  {hasPermission(PERMISSIONS.VIEW_CHAT) && (
                    <Menu.Item className="flex hover:text-[#00B2A4]">
                      {({ active }) => (
                        <Link to={`/chats`} className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm uppercase')}>
                          Сообщения
                        </Link>
                      )}
                    </Menu.Item>
                  )}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
      </nav>
    </div>
  );
}

export default NavBar;
